import React, { useMemo } from 'react';
import { Box, LinearProgress, Skeleton, Typography } from '@mui/material';

const LanguageBreakdown = ({ languageBreakdown, data, loading = false }) => {
  const topLanguages = useMemo(() => {
    const source = languageBreakdown || data || [];
    return [...source]
      .sort((a, b) => (b?.count || 0) - (a?.count || 0))
      .slice(0, 5);
  }, [languageBreakdown, data]);

  const maxCount = topLanguages[0]?.count || 0;

  if (loading) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {[1, 2, 3].map((item) => (
          <Box key={item} sx={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 1, alignItems: 'center' }}>
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton variant="text" width={30} height={20} />
            <Box sx={{ gridColumn: '1 / -1' }}>
              <Skeleton variant="rounded" height={7} />
            </Box>
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {topLanguages.map((item) => {
        const language = item?.language || 'Unknown';
        const count = item?.count || 0;
        const progress = maxCount > 0 ? Math.round((count / maxCount) * 100) : 0;

        return (
          <Box key={language} sx={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 1, alignItems: 'center' }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {language}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {count}
            </Typography>
            <Box sx={{ gridColumn: '1 / -1' }}>
              <LinearProgress
                variant="determinate"
                value={progress}
                sx={{
                  height: 7,
                  borderRadius: 999,
                  bgcolor: 'action.hover',
                }}
              />
            </Box>
          </Box>
        );
      })}
      {topLanguages.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No language data
        </Typography>
      ) : null}
    </Box>
  );
};

export default LanguageBreakdown;
